export const WISHLIST_ENDPOINTS = {
  SAVED_ITEMS: '/customer/saved-items/',
  ITEM_DETAIL: (slug: string) => `/customer/saved-items/${slug}/`,
} as const
